import { c as _c } from "react/compiler-runtime";
import { FlexItem } from '@/components/Atoms/FlexItem/FlexItem';
import { GridWrapper } from '@/components/Atoms/GridWrapper/GridWrapper';
import { P } from '@/components/Atoms/P/P';
import { type QuickSearchContentResults, useGlobalSearchContext } from '@/contexts/GlobalSearchContext';
import useTranslation from '@/hooks/useTranslation';
import styled from 'styled-components';
import { ContentResultsSection } from './ContentResultsSection';
import { JumpToResultsSection } from './JumpToResultsSection';
export const ResultSection = () => {
  const $ = _c(8);
  const {
    activeQuery,
    globalSearchResults,
    currentJumpToResults,
    isLoading
  } = useGlobalSearchContext();
  const {
    t
  } = useTranslation("common");
  const {
    resultGroups
  } = globalSearchResults ?? {};
  const {
    authors
  } = resultGroups as QuickSearchContentResults['resultGroups'] ?? {};
  const contentResultsCount = globalSearchResults ? globalSearchResults.totalResults : 0;
  const hasJumpTo = currentJumpToResults?.length > 0 || (authors?.items.length || 0) > 0;
  if (!activeQuery) {
    return null;
  }
  if (contentResultsCount > 0 && hasJumpTo) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <FlexItem $m={30} $l={15}><JumpToResultsSection /></FlexItem>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <GridWrapper>{t0}<FlexItem $m={70} $l={85}><ContentResultsSection /></FlexItem></GridWrapper>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (contentResultsCount > 0) {
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <StyledResultWrapper><ContentResultsSection /></StyledResultWrapper>;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  if (hasJumpTo) {
    let t0;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <JumpToResultsSection />;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  if (activeQuery && !isLoading) {
    let t0;
    if ($[4] !== t) {
      t0 = t("Filter.no_results");
      $[4] = t;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    let t1;
    if ($[6] !== t0) {
      t1 = <P size="xlarge"><strong>{t0}</strong></P>;
      $[6] = t0;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  return null;
};
const StyledResultWrapper = styled.div`
    padding-bottom: var(--size-grid-unit);
`;